import React, { useEffect, useRef, useState } from 'react';
import MainLogo from '../Common/MainLogo';
import GlobalNav from './GlobalNav';
import LanguageToggleButtonGroup from '../Button/LanguageToggleButtonGroup';
import MyPageToggleButtonGroup from '../Button/MyPageToggleButtonGroup';
import DownloadButton from '../Button/DownloadButton';
import ModalWrapper from '../Modal/ModalWrapper';
import DownloadItemsWrapper from '../Common/DownloadItemsWrapper';
import HamburgerButton from '../Button/HamburgerButton';
import useGetBeatInfo from '../../hooks/useGetBeatInfo';
import useCheckTokenExpiry from '../../hooks/useCheckTokenExpiry';
import { useRecoilValue } from 'recoil';
import { countryState } from '../../recoil/country/countryAtom';
import * as Sentry from '@sentry/react';

const MlHeader = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [mobileGnbOpen, setMobileGnbOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const headerRef = useRef(null);

  const accessToken = localStorage.getItem('access_token');
  const countryData = useRecoilValue(countryState);
  const exp = localStorage.getItem('exp');

  const { isLogin, hasAccessToken } = useGetBeatInfo(accessToken, countryData?.country);
  const isAccessTokenExpired = useCheckTokenExpiry(exp);

  const handleScroll = () => {
    const offset = window.scrollY;
    const headerHeight = headerRef.current.clientHeight; // 헤더의 높이
    if (offset > headerHeight) {
      setIsScrolled(true);
    } else {
      setIsScrolled(false);
    }
  };

  const openDownloadModal = () => {
    setIsOpen(true);
  };

  const toggleMobileGnb = () => {
    setMobileGnbOpen(!mobileGnbOpen);
  };

  useEffect(() => {
    const clearSession = () => {
      localStorage.removeItem('access_token');
      localStorage.removeItem('userInfo');
      localStorage.removeItem('exp');
      Sentry.setUser(null);
    };

    const handleLoginCheck = () => {
      if (hasAccessToken === false) {
        clearSession();
        return false;
      }

      if (isAccessTokenExpired) {
        clearSession();
        return false;
      }
    };

    setTimeout(() => {
      handleLoginCheck();
    }, 1000);
  }, [isLogin, exp, hasAccessToken]);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  // 모바일 햄버거 메뉴 노출 시 body 스크롤바 제거
  useEffect(() => {
    if (mobileGnbOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
  }, [mobileGnbOpen]);

  return (
    <>
      <header ref={headerRef} className={`ml-header ${isScrolled ? 'is-scrolled' : ''}`}>
        <div className={'ml-header-inner'}>
          <div className={'ml-header-layout-wrapper'}>
            <div className={'ml-header-left-group'}>
              <MainLogo goHome={true} />
            </div>
            <div className={'ml-header-right-group'}>
              <GlobalNav isOpen={mobileGnbOpen} onToggle={toggleMobileGnb} isLogin={isLogin} />
              <div className={'mb-hide'}>
                <DownloadButton onClick={openDownloadModal} />
              </div>
              <div className={'header-side-button-group'}>
                <LanguageToggleButtonGroup />
                <MyPageToggleButtonGroup isLogin={isLogin} />
                <div className={'mb-show'}>
                  <HamburgerButton isOpen={mobileGnbOpen} onClick={toggleMobileGnb} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
      <ModalWrapper
        isOpen={isOpen}
        size={'sm'}
        noScroll={true}
        onClose={() => {
          setIsOpen(false);
        }}
      >
        <DownloadItemsWrapper title={'Download Mubeat'} />
      </ModalWrapper>
    </>
  );
};

export default MlHeader;
